import { render, staticRenderFns } from "./MoleculeFeedProjectsSearch.vue?vue&type=template&id=ef5d5bdc&"
import script from "./MoleculeFeedProjectsSearch.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedProjectsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports